import { Component, Input, OnInit } from '@angular/core';
import { NotificationModel } from '@evorait/pace-core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-eta-alert',
    templateUrl: './eta-alert.component.html',
    styleUrls: ['./eta-alert.component.scss'],
})
export class EtaAlertComponent implements OnInit {
    @Input()
    public notification: NotificationModel;

    @Input()
    public etaStartTime: moment.Moment;

    public durationLeftInMinutes: number;
    public constructor(public readonly modalInstance: BsModalRef) {}

    public ngOnInit(): void {
        this.durationLeftInMinutes = Math.ceil(moment.duration(moment(this.etaStartTime).diff(moment())).asMinutes());
    }
}
